import { ThemeOptions } from '@mui/material';

import robotoLightWoff from '../fonts/hinted-subset-Roboto-Light.woff';
import robotoLightWoff2 from '../fonts/hinted-subset-Roboto-Light.woff2';
import robotoRegularWoff from '../fonts/hinted-subset-Roboto-Regular.woff';
import robotoRegularWoff2 from '../fonts/hinted-subset-Roboto-Regular.woff2';
import robotoMediumWoff from '../fonts/hinted-subset-Roboto-Medium.woff';
import robotoMediumWoff2 from '../fonts/hinted-subset-Roboto-Medium.woff2';
import robotoBoldWoff from '../fonts/hinted-subset-Roboto-Bold.woff';
import robotoBoldWoff2 from '../fonts/hinted-subset-Roboto-Bold.woff2';
import ubuntuMono from '../fonts/hinted-subset-UbuntuMono-Regular.woff';
import hauoraBold from '../fonts/Hauora-Bold.woff2';
import hauoraExtraBold from '../fonts/Hauora-ExtraBold.woff2';
import hauoraExtraLight from '../fonts/Hauora-ExtraLight.woff2';
import hauoraLight from '../fonts/Hauora-Light.woff2';
import hauoraMedium from '../fonts/Hauora-Medium.woff2';
import hauoraRegular from '../fonts/Hauora-Regular.woff2';
import hauoraSemiBold from '../fonts/Hauora-SemiBold.woff2';


export const fontsOptions: ThemeOptions = {
    typography: {
        fontFamily: 'Roboto',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': [
                    {
                        fontWeight: 300,
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        src: `local(''), url(${robotoLightWoff2}) format('woff2'), url(${robotoLightWoff}) format('woff')`,
                    },
                    {
                        fontWeight: 'normal',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        src: `local(''), url(${robotoRegularWoff2}) format('woff2'), url(${robotoRegularWoff}) format('woff')`,
                    },
                    {
                        fontWeight: 500,
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        src: `local(''), url(${robotoMediumWoff2}) format('woff2'), url(${robotoMediumWoff}) format('woff')`,
                    },
                    {
                        fontWeight: 'bold',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        src: `local(''), url(${robotoBoldWoff2}) format('woff2'), url(${robotoBoldWoff}) format('woff')`,
                    },
                    {
                        fontWeight: 'normal',
                        fontFamily: 'Ubuntu Mono',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        src: `url(${ubuntuMono}) format('woff')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 200,
                        src: `local(''), url(${hauoraExtraLight}) format('woff2')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 300,
                        src: `local(''), url(${hauoraLight}) format('woff2')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 400,
                        src: `local(''), url(${hauoraRegular}) format('woff2')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 500,
                        src: `local(''), url(${hauoraMedium}) format('woff2')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 600,
                        src: `local(''), url(${hauoraSemiBold}) format('woff2')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 700,
                        src: `local(''), url(${hauoraBold}) format('woff2')`,
                    },
                    {
                        fontFamily: 'Hauora',
                        fontStyle: 'normal',
                        fontDisplay: 'swap',
                        fontWeight: 800,
                        src: `local(''), url(${hauoraExtraBold}) format('woff2')`,
                    },
                ],
            },
        },
    },
};
